import React from 'react'
import Typed from 'react-typed'
import {Link} from 'react-router-dom'
import { useTranslation } from 'react-i18next';
// import './i18n';

const Header = () => {
    const { t, i18n } = useTranslation();

     return (
        <div className="header-wrapper text-center d-flex align-items-center">
            <div className="main-info m-auto"><br/>
                 
                <h1>{t('full stack web developer')}</h1>
                <br/><br/><br/><br/>
                 <Typed 
                    className="typed m-3"
                    strings={["WEB Design","WEB Deployment","PWA/Android/IOS","Clouds","Network : Switching / Routing / vps","Pen-test"]}
                    typeSpeed={ 100 }
                    backSpeed={ 50 }
                    loop
                />
                <br/>
                <a href="#" className=" btn-main m-2">
                    <Link to="/contact" className="text-light"> {t('contact')}</Link>
                </a>
            
            </div>
        </div>
    )
}

export default Header
